// Guard das rotas privadas. Sem token → /login. Envolve o conteúdo no
// AppShell (sidebar + topo). `acess` opcional restringe por papel (tipo/role).
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../auth/storage';
import AppShell from './AppShell';

export default function RequireAuth({ element, acess }) {
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }
    if (acess != null) {
        const user = getUser();
        const role = user?.tipo || user?.role;
        if (!acess.includes(role)) return <Navigate to="/" replace />;
    }
    return <AppShell>{element}</AppShell>;
}
